/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { Teams } from '../../utils/api';
import { AdminHeader, AdminContent } from './styles';
import { ARMcontext } from '../../utils/context/context';
import { Billing, Customization, ManageCoaches, ManagePlayers } from './';
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { FiltersContainer, LargeButton, Navbar, Tabs, FluidContainer } from '../../components';
import { TeamsCacheKey } from '../../utils/constants/keyCache';

const Default = [
  {
    title: 'Manage players',
    url: 'ManagePlayers',
  },
  {
    title: 'Manage coaches',
    url: 'ManageCoaches',
  },
  {
    title: 'Billing',
    url: 'billing',
  },
  {
    title: 'Customization',
    url: 'customization',
  },
];

export default () => {
  const { teamMemo, AddNewTeams, user } = useContext(ARMcontext);
  const [modal, useModal] = useState(false);
  const { pathname } = useLocation();
  const navigation = useNavigate();
  const Team = new Teams();

  const DefaultPills = Default.filter(el => {
    if (el.title === 'Customization') {
      return false;
    } else if (el.title === 'Billing') {
      return user.role === 'org-admin';
    } else {
      return true;
    }
  });

  useEffect(() => {
    if (!window.location.href.includes('/admin/')) {
      navigation('/admin/ManagePlayers');
    }
    FetchTeams();
  }, [history]);

  function HandleModal(value = true) {
    useModal(value);
  }

  async function FetchTeams(): Promise<void> {
    const res = await Team.ExecuteCacheRequest({
      cacheKey: TeamsCacheKey,
      queryFn: Team.GetMyTeams,
    });
    const allValues = {
      pitchers: res.data.meta.players.onlyPrimary.pitchers,
      catchers: res.data.meta.players.onlyPrimary.catchers,
      infielders: res.data.meta.players.onlyPrimary.infielders,
      outfielders: res.data.meta.players.onlyPrimary.outfielders,
    };
    const AllPlayers = {
      ...allValues,
      age: [],
      color: '#007AFF',
      badge: 'ALL',
      name: 'All Players',
      totalPlayers: allValues.pitchers + allValues.catchers + allValues.infielders + allValues.outfielders,
      __name: 'All Players',
      __organization: 'ARM CARE',
      __organizationToStr: 'ARM CARE',
    };

    AddNewTeams([AllPlayers, ...res.data.teams]);
  }

  return (
    <>
      <Navbar />
      <FiltersContainer bColor="var(--BackgroundGrey)">
        <AdminHeader data-cy="admin-filters">
          <Tabs dataArray={DefaultPills} url={'/admin'} dataCy="admin-tabs" />
          {window.location.href.includes('ManageCoaches') ? (
            <LargeButton
              title="ADD COACHES"
              lColor="var(--SecondaryBlue);"
              rColor="var(--PrimaryBlue);"
              icon="plus"
              responsive="735px"
              callback={HandleModal}
            />
          ) : (
            <></>
          )}
        </AdminHeader>
      </FiltersContainer>
      <AdminContent>
        <FluidContainer>
          <Routes>
            <Route path={`:adminId/*`} element={<AdminRouter teamMemo={teamMemo} modal={modal} useModal={useModal} user={user} />}>

            </Route>
          </Routes>
        </FluidContainer>
      </AdminContent>
    </>
  );
};

const AdminRouter = ({ teamMemo, modal, useModal, user }) => {
  const { adminId } = useParams() as any;
  return (
    <>
      {adminId === 'ManagePlayers' ? (
        <ManagePlayers teamMemo={teamMemo} modal={modal} useModal={useModal} />
      ) : adminId === 'ManageCoaches' ? (
        <ManageCoaches teamMemo={teamMemo} modal={modal} useModal={useModal} />
      ) : (user.role === 'org-admin' && adminId === 'billing') ? (
        <Billing />
      ) : adminId === 'customization' ? (
        <Customization />
      ) : (
        <></>
      )}
    </>
  );
};
